import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=652aca98&scoped=true&"
import script from "./complaints.vue?vue&type=script&lang=js&"
export * from "./complaints.vue?vue&type=script&lang=js&"
import style0 from "./complaints.vue?vue&type=style&index=0&id=652aca98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652aca98",
  null
  
)

export default component.exports